import * as React from 'react';
import {useI18N} from "../../../../my-puratos/hoc/withI18N";
import {ProductContext} from "../../../../pages/ProductStencil";
import { useContext } from 'react';

export function NoEcommerce() {

    const translate = useI18N();
    const {contactUsFindStockist} = useContext(ProductContext);

    if (!contactUsFindStockist?.distributorsLink && !contactUsFindStockist?.contactUsLink) {
        return null;
    }

    return (
        <div className="sign-in">
            <div className="sign-in__buttons">
                { contactUsFindStockist?.distributorsLink && 
                    (<button className="btn btn-primary" onClick={() => window.location.href = contactUsFindStockist?.distributorsLink?.url}>
                        {translate(contactUsFindStockist?.distributorsLink?.label)}
                    </button>)
                }

                { contactUsFindStockist?.contactUsLink && 
                    (<button className="btn btn-secondary" onClick={() => window.location.href = contactUsFindStockist?.contactUsLink?.url}>
                        {translate(contactUsFindStockist?.contactUsLink?.label)}
                    </button>)
                }
            </div>
            <div className="benefits" dangerouslySetInnerHTML={{ __html: contactUsFindStockist?.text }} />
        </div>
    );
}
